import(/* webpackMode: "eager" */ "/app/src/app/about/quy-trinh/to-chuc/page.tsx");
